var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-jackpot-badge"},[_c('h2',{staticClass:"c-jackpot-badge__title"},[_vm._v(" "+_vm._s(_vm.$t("general.jackpot"))+" ")]),_c('span',{staticClass:"c-jackpot-badge__value"},[_vm._v(_vm._s(this.$store.getters.getJackpot))])])
}
var staticRenderFns = []

export { render, staticRenderFns }